// Merging translation catalogues, branch by branch.
//
// Its own file with no imports on purpose: the app uses it to build the
// runtime catalogue and the i18n test uses it to check the same catalogue.
// Two implementations of this would mean a test that passes on a merge the
// application never performs.
//
// Why not a plain spread: a module names itself inside blocks the shell also
// owns — `settings.ns.<module>`, `permissions.<module>`, `audit.actions.<module>`,
// `modules.<module>`. A shallow merge makes one side's whole block replace the
// other's, so either the module's screens or the platform's render raw keys.

const isPlainObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value)

/**
 * Deep-merges `extra` over `base`. On a leaf clash `extra` wins.
 * Callers pass the shell as `extra`: a module fills gaps, it never rewrites
 * platform copy.
 */
export function mergeMessages(base, extra) {
  const result = { ...base }
  for (const [key, value] of Object.entries(extra ?? {})) {
    const current = result[key]
    result[key] = isPlainObject(current) && isPlainObject(value)
      ? mergeMessages(current, value)
      : value
  }
  return result
}
